import React, { useState, useEffect } from 'react';
import { FiSun, FiMoon } from 'react-icons/fi';

const ThemeToggle = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem('codeTheme');
    if (savedTheme === 'dark') {
      setIsDark(true);
      document.body.classList.add('dark-code-theme');
    } else {
      // Default is light theme
      setIsDark(false);
      document.body.classList.remove('dark-code-theme');
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = !isDark;
    setIsDark(newTheme);
    
    if (newTheme) {
      // Switch to dark theme
      document.body.classList.add('dark-code-theme');
      localStorage.setItem('codeTheme', 'dark');
    } else {
      // Switch to light theme (default)
      document.body.classList.remove('dark-code-theme');
      localStorage.setItem('codeTheme', 'light');
    }
  };

  return (
    <button 
      onClick={toggleTheme}
      className="theme-toggle-btn"
      title={isDark ? 'Switch to Light Code Theme' : 'Switch to Dark Code Theme'}
    >
      {isDark ? <FiSun /> : <FiMoon />}
      <span>{isDark ? 'Light Code' : 'Dark Code'}</span>
    </button>
  );
};

export default ThemeToggle;

